import React from 'react';
import { useLang } from '../context/LangContext';
import { Globe } from 'lucide-react';

const LangSwitcher = ({ compact = false }) => {
  const { lang, setLang } = useLang();

  if (compact) {
    return (
      <button
        onClick={() => setLang(lang === 'es' ? 'en' : 'es')}
        className="inline-flex items-center gap-1.5 px-2.5 h-8 rounded-full border border-white/15 bg-white/[0.03] hover:bg-white/[0.08] text-white/70 hover:text-white text-[11px] font-medium uppercase tracking-widest transition-colors"
        title="Change language"
      >
        <Globe className="w-3 h-3" />
        {lang === 'es' ? 'ES' : 'EN'}
      </button>
    );
  }

  return (
    <div className="inline-flex items-center gap-0.5 p-0.5 rounded-full border border-white/15 bg-white/[0.03]">
      <button
        onClick={() => setLang('es')}
        className={`px-3 h-8 rounded-full text-[11px] uppercase tracking-widest font-medium transition-colors ${
          lang === 'es'
            ? 'bg-[#00e0c7]/20 text-[#9be8dc]'
            : 'text-white/50 hover:text-white'
        }`}
      >
        ES
      </button>
      <button
        onClick={() => setLang('en')}
        className={`px-3 h-8 rounded-full text-[11px] uppercase tracking-widest font-medium transition-colors ${
          lang === 'en'
            ? 'bg-[#00e0c7]/20 text-[#9be8dc]'
            : 'text-white/50 hover:text-white'
        }`}
      >
        EN
      </button>
    </div>
  );
};

export default LangSwitcher;
